import axios from "axios";
import { toast } from "react-toastify";

import { SERVER_URL } from "../config/config";
import store from "../store";

export const ApiClient = axios.create({
  baseURL: SERVER_URL,
});

ApiClient.interceptors.request.use(function (config) {
  const token = store.getState().login?.token;
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

ApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error.response);
    if (error.response.status === 400) {
      toast.error(error.response.data.message);
    } else if (error.response.status === 422) {
      toast.error("Something went wrong");
    } else if (error.response.status === 500) {
      toast.error("Internal Server Error");
    } else {
      toast.error(error.response.data.message);
    }
    return Promise.reject(error);
  }
);
